export type LightboxBinding = {
    $items: JQuery<HTMLElement>,
    instance: {
        destroy: () => void,
    },
};

function bindLightboxItems($items: JQuery<HTMLElement>): LightboxBinding|null {
    $items.simpleLightbox();
    $items.addClass('event-binded');

    const instance = $items.first().data('simpleLightbox');
    return instance && typeof instance.destroy === 'function'
        ? {$items, instance}
        : null;
}

export function bindLightboxes($root: JQuery<HTMLElement|Element>): LightboxBinding[] {
    const bindings: LightboxBinding[] = [];

    // grouped galleries — anchors sharing the same data-lightbox-gallery open as one gallery with prev/next arrows
    const galleries: { [name: string]: JQuery<HTMLElement> } = {};
    $root.find('.lightbox a[data-lightbox-gallery]').not('.event-binded').each((i, el) => {
        const $el = $(el);
        const name = $el.attr('data-lightbox-gallery');
        if (name) {
            galleries[name] = (galleries[name] || $()).add($el);
        }
    });
    Object.keys(galleries).forEach((name) => {
        const binding = bindLightboxItems(galleries[name]);
        if (binding) {
            bindings.push(binding);
        }
    });

    // ungrouped single-image lightboxes (original behaviour)
    $root.find('.lightbox a').not('.event-binded').not('[data-lightbox-gallery]').each((i, el) => {
        const binding = bindLightboxItems($(el));
        if (binding) {
            bindings.push(binding);
        }
    });

    // assign lightbox to img (if not part of image rating)
    if ($root.find('.post-content div[data-component-image-rating-view] img').length === 0 && $root.find('.post-content img[data-component-image-rating]').length === 0) {
        $root.find('.post-content img').not('.event-binded').not('[src^="/build/"]').each((i, el) => {
            const $el = $(el);

            // check if is in <a>
            if ($el.parent('a').length === 0) {
                const $imgClone = $el.clone();
                const $aEl = $('<a>');
                $aEl.attr('href', $el.attr('src'));
                $aEl.append($imgClone);
                $el.replaceWith($aEl);

                const binding = bindLightboxItems($aEl);
                if (binding) {
                    bindings.push(binding);
                }
            } else {
                const $aEl = $el.parent('a');
                if (!$aEl.hasClass('event-binded')) {
                    const binding = bindLightboxItems($aEl);
                    if (binding) {
                        bindings.push(binding);
                    }
                }
            }
        });
    }

    return bindings;
}

export function destroyLightboxes(bindings: LightboxBinding[]): void {
    bindings.forEach(({instance, $items}) => {
        instance.destroy();
        $items.removeData('simpleLightbox');
        $items.removeClass('event-binded');
    });
}
